// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XraNfTAFDW1EpE7ox781 {
  background-color: var(--search-input-wrapper-background)
}

.XraNfTAFDW1EpE7ox781 .g6Kfcqh7GUhDpejD4OT8 {
    max-width: 27rem;
    background-color: var(--search-input-background);
    padding: 0.875rem 1.375rem;
    border-radius: 2rem;
  }

.XraNfTAFDW1EpE7ox781 .hxt8jgHsvKdz2diVM0Bk {
    background-color: var(--search-input-background);
    color: var(--search-input-font-color);
    caret-color: var(--search-input-font-color);
  }

.XraNfTAFDW1EpE7ox781 .hxt8jgHsvKdz2diVM0Bk::placeholder {
    color: var(--search-input-placeholder-color);
  }

.y6FAa29hu_eQwYp02Y0L {
  background-color: var(--grey-100)
}

.y6FAa29hu_eQwYp02Y0L .hxt8jgHsvKdz2diVM0Bk {
    background-color: var(--grey-100);
    color: var(--midnight-purple);
    caret-color: var(--midnight-purple);
  }

.y6FAa29hu_eQwYp02Y0L .hxt8jgHsvKdz2diVM0Bk::placeholder {
    color: var(--midnight-purple);
    opacity: 40%;
  }

.L1RSPftWJw_ZdBQjuote {
  width: 100%
}

.L1RSPftWJw_ZdBQjuote .FZM5_w6eqhDv020n9koz {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 90rem;
    margin: 0 auto;
    padding-top: var(--vertical-padding);
    padding-bottom: var(--vertical-padding);
    padding-left: var(--horizontal-padding);
    padding-right: var(--horizontal-padding)
  }

.L1RSPftWJw_ZdBQjuote .FZM5_w6eqhDv020n9koz .g6Kfcqh7GUhDpejD4OT8 {
      display: flex;
      align-items: center;
      flex-grow: 1
    }

.L1RSPftWJw_ZdBQjuote .FZM5_w6eqhDv020n9koz .g6Kfcqh7GUhDpejD4OT8.Pb3U9czlHIhnJ7HoifVy {
        border-bottom: 0;
      }

.L1RSPftWJw_ZdBQjuote .FZM5_w6eqhDv020n9koz .g6Kfcqh7GUhDpejD4OT8 .MwPZaNi0640F5UppmC8b {
        margin-right: 0.875rem;
      }

.L1RSPftWJw_ZdBQjuote .FZM5_w6eqhDv020n9koz .g6Kfcqh7GUhDpejD4OT8 .pDUlj2G4eUTKX9g69ohj {
        margin-right: 0.84375rem;
        cursor: pointer;
      }

.L1RSPftWJw_ZdBQjuote .FZM5_w6eqhDv020n9koz .g6Kfcqh7GUhDpejD4OT8 .hxt8jgHsvKdz2diVM0Bk {
        margin: 0;
        padding: 0;
        border: 0;
        width: 100%;
        font-size: 1.125rem;
        line-height: 1.375rem;
        appearance: none;
        outline: none;
      }

.L1RSPftWJw_ZdBQjuote .FZM5_w6eqhDv020n9koz .g6Kfcqh7GUhDpejD4OT8 .hxt8jgHsvKdz2diVM0Bk:focus {
        outline: none;
      }

.L1RSPftWJw_ZdBQjuote .FZM5_w6eqhDv020n9koz .g6Kfcqh7GUhDpejD4OT8 .hxt8jgHsvKdz2diVM0Bk::placeholder {
        font-weight: normal;
        line-height: 1.375rem;
      }

.Oljo9rSuzJNuQMilJ369 {
  cursor: pointer;
}

@media only screen and
  (min-width: 1280px) {
    .L1RSPftWJw_ZdBQjuote .FZM5_w6eqhDv020n9koz {
      --vertical-padding: 0.9375rem;
      --horizontal-padding: 4rem;
    }
      .L1RSPftWJw_ZdBQjuote.y6FAa29hu_eQwYp02Y0L .FZM5_w6eqhDv020n9koz {
        --vertical-padding: 1.8125rem;
      }
}

@media only screen and
  (min-width: 1024px) and
  (max-width: 1279px) {
    .L1RSPftWJw_ZdBQjuote .FZM5_w6eqhDv020n9koz {
      --vertical-padding: 0.9375rem;
      --horizontal-padding: 3rem;
    }
      .L1RSPftWJw_ZdBQjuote.y6FAa29hu_eQwYp02Y0L .FZM5_w6eqhDv020n9koz {
        --vertical-padding: 1.8125rem;
      }
}

@media only screen and
  (min-width: 640px) and
  (max-width: 1023px) {
    .L1RSPftWJw_ZdBQjuote .FZM5_w6eqhDv020n9koz {
      --vertical-padding: 0.9375rem;
      --horizontal-padding: 2rem;
    }
      .L1RSPftWJw_ZdBQjuote.y6FAa29hu_eQwYp02Y0L .FZM5_w6eqhDv020n9koz {
        --vertical-padding: 1.5rem;

        padding-bottom: 0
      }

        .L1RSPftWJw_ZdBQjuote.y6FAa29hu_eQwYp02Y0L .FZM5_w6eqhDv020n9koz .g6Kfcqh7GUhDpejD4OT8 {
          border-bottom: 0.125rem solid var(--white-012);
          padding-bottom: 1rem;
        }

  .iV1fB9Z1h0xkrgFcEFPJ a {
    max-width: 7.5rem;
  }
}

@media only screen and
  (max-width: 639px) {
  .g6Kfcqh7GUhDpejD4OT8 {
    max-width: 100%;
  }
    .L1RSPftWJw_ZdBQjuote .FZM5_w6eqhDv020n9koz {
      display: block;
      --vertical-padding: 0.9375rem;
      --horizontal-padding: 1rem;
    }
      .L1RSPftWJw_ZdBQjuote.y6FAa29hu_eQwYp02Y0L .FZM5_w6eqhDv020n9koz {
        --vertical-padding: 1.5rem;

        padding-bottom: 0
      }

        .L1RSPftWJw_ZdBQjuote.y6FAa29hu_eQwYp02Y0L .FZM5_w6eqhDv020n9koz .g6Kfcqh7GUhDpejD4OT8 {
          border-bottom: 0.125rem solid var(--white-012);
          padding-bottom: 1rem;
        }
    .iV1fB9Z1h0xkrgFcEFPJ a {
      max-width: 6.25rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/SearchInput/SearchInput.module.css"],"names":[],"mappings":"AAAA;EACE;AAkBF;;AAhBE;IACE,gBAAgB;IAChB,gDAAgD;IAChD,0BAAkB;IAClB,mBAAmB;EACrB;;AAEA;IACE,gDAAgD;IAChD,qCAAqC;IACrC,2CAA2C;EAC7C;;AAEA;IACE,4CAA4C;EAC9C;;AAGF;EACE;AAYF;;AAVE;IACE,iCAAiC;IACjC,6BAA6B;IAC7B,mCAAmC;EACrC;;AAEA;IACE,6BAA6B;IAC7B,YAAY;EACd;;AAGF;EACE;AAoDF;;AAlDE;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAiB;IACjB,cAAc;IACd,oCAAoC;IACpC,uCAAuC;IACvC,uCAAuC;IACvC;EAwCF;;AAtCE;MACE,aAAa;MACb,mBAAmB;MACnB;IAkCF;;AAhCE;QACE,gBAAgB;MAClB;;AAEA;QACE,sBAAkB;MACpB;;AAEA;QACE,wBAAoB;QACpB,eAAe;MACjB;;AAEA;QACE,SAAS;QACT,UAAU;QACV,SAAS;QACT,WAAW;QACX,mBAAe;QACf,qBAAiB;QACjB,gBAAgB;QAChB,aAAa;MACf;;AAEA;QACE,aAAa;MACf;;AAEA;QACE,mBAAmB;QACnB,qBAAiB;MACnB;;AAKN;EACE,eAAe;AACjB;;AAEA;;IAEI;MACE,6BAAwB;MACxB,0BAA0B;IAC5B;MAGE;QACE,6BAAwB;MAC1B;AAGN;;AAEA;;;IAEI;MACE,6BAAwB;MACxB,0BAA0B;IAC5B;MAGE;QACE,6BAAwB;MAC1B;AAGN;;AAEA;;;IAEI;MACE,6BAAwB;MACxB,0BAA0B;IAC5B;MAGE;QACE,0BAAwB;;QAExB;MAMF;;QAJE;UACE,8CAAyC;UACzC,oBAAoB;QACtB;;EAKN;IACE,iBAAgB;EAClB;AACF;;AAEA;;EACE;IACE,eAAe;EACjB;IAGE;MACE,cAAc;MACd,6BAAwB;MACxB,0BAA0B;IAC5B;MAGE;QACE,0BAAwB;;QAExB;MAMF;;QAJE;UACE,8CAAyC;UACzC,oBAAoB;QACtB;IAMJ;MACE,kBAAgB;IAClB;AAEJ","sourcesContent":[".white {\n  background-color: var(--search-input-wrapper-background);\n\n  & .iconAndInputWrapper {\n    max-width: 432px;\n    background-color: var(--search-input-background);\n    padding: 14px 22px;\n    border-radius: 32px;\n  }\n\n  & .input {\n    background-color: var(--search-input-background);\n    color: var(--search-input-font-color);\n    caret-color: var(--search-input-font-color);\n  }\n\n  & .input::placeholder {\n    color: var(--search-input-placeholder-color);\n  }\n}\n\n.grey {\n  background-color: var(--grey-100);\n\n  & .input {\n    background-color: var(--grey-100);\n    color: var(--midnight-purple);\n    caret-color: var(--midnight-purple);\n  }\n\n  & .input::placeholder {\n    color: var(--midnight-purple);\n    opacity: 40%;\n  }\n}\n\n.searchInput {\n  width: 100%;\n\n  & .searchInputInner {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    max-width: 1440px;\n    margin: 0 auto;\n    padding-top: var(--vertical-padding);\n    padding-bottom: var(--vertical-padding);\n    padding-left: var(--horizontal-padding);\n    padding-right: var(--horizontal-padding);\n\n    & .iconAndInputWrapper {\n      display: flex;\n      align-items: center;\n      flex-grow: 1;\n\n      &.active {\n        border-bottom: 0;\n      }\n\n      & .loupe {\n        margin-right: 14px;\n      }\n\n      & .circleAndLeftPointedArrow {\n        margin-right: 13.5px;\n        cursor: pointer;\n      }\n\n      & .input {\n        margin: 0;\n        padding: 0;\n        border: 0;\n        width: 100%;\n        font-size: 18px;\n        line-height: 22px;\n        appearance: none;\n        outline: none;\n      }\n\n      & .input:focus {\n        outline: none;\n      }\n\n      & .input::placeholder {\n        font-weight: normal;\n        line-height: 22px;\n      }\n    }\n  }\n}\n\n.clearIcon {\n  cursor: pointer;\n}\n\n@media (--desktop-large) {\n  .searchInput {\n    & .searchInputInner {\n      --vertical-padding: 15px;\n      --horizontal-padding: 64px;\n    }\n\n    &.grey {\n      & .searchInputInner {\n        --vertical-padding: 29px;\n      }\n    }\n  }\n}\n\n@media (--desktop-small) {\n  .searchInput {\n    & .searchInputInner {\n      --vertical-padding: 15px;\n      --horizontal-padding: 48px;\n    }\n\n    &.grey {\n      & .searchInputInner {\n        --vertical-padding: 29px;\n      }\n    }\n  }\n}\n\n@media (--tablet) {\n  .searchInput {\n    & .searchInputInner {\n      --vertical-padding: 15px;\n      --horizontal-padding: 32px;\n    }\n\n    &.grey {\n      & .searchInputInner {\n        --vertical-padding: 24px;\n\n        padding-bottom: 0;\n\n        & .iconAndInputWrapper {\n          border-bottom: 2px solid var(--white-012);\n          padding-bottom: 16px;\n        }\n      }\n    }\n  }\n\n  .trustmarks a {\n    max-width: 120px;\n  }\n}\n\n@media (--mobile) {\n  .iconAndInputWrapper {\n    max-width: 100%;\n  }\n\n  .searchInput {\n    & .searchInputInner {\n      display: block;\n      --vertical-padding: 15px;\n      --horizontal-padding: 16px;\n    }\n\n    &.grey {\n      & .searchInputInner {\n        --vertical-padding: 24px;\n\n        padding-bottom: 0;\n\n        & .iconAndInputWrapper {\n          border-bottom: 2px solid var(--white-012);\n          padding-bottom: 16px;\n        }\n      }\n    }\n  }\n\n  .trustmarks {\n    & a {\n      max-width: 100px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"white": `XraNfTAFDW1EpE7ox781`,
	"iconAndInputWrapper": `g6Kfcqh7GUhDpejD4OT8`,
	"input": `hxt8jgHsvKdz2diVM0Bk`,
	"grey": `y6FAa29hu_eQwYp02Y0L`,
	"searchInput": `L1RSPftWJw_ZdBQjuote`,
	"searchInputInner": `FZM5_w6eqhDv020n9koz`,
	"active": `Pb3U9czlHIhnJ7HoifVy`,
	"loupe": `MwPZaNi0640F5UppmC8b`,
	"circleAndLeftPointedArrow": `pDUlj2G4eUTKX9g69ohj`,
	"clearIcon": `Oljo9rSuzJNuQMilJ369`,
	"trustmarks": `iV1fB9Z1h0xkrgFcEFPJ`
};
export default ___CSS_LOADER_EXPORT___;
